import i18n from "@/plugins/i18n";

export enum ZincCoating {
	None = 0,
	HotDip = 1,
	Galvanize = 2,
	Both = 3, // Only exists in frontend
}

export const getZincCoatingText = (zincCoating: ZincCoating): string => {
	const coatingMap: Record<ZincCoating, string> = {
		[ZincCoating.None]: i18n.t("dtoLabels.zincCoating.none") as string,
		[ZincCoating.HotDip]: i18n.t("dtoLabels.zincCoating.hotDip") as string,
		[ZincCoating.Galvanize]: i18n.t("dtoLabels.zincCoating.galvanize") as string,
		[ZincCoating.Both]: i18n.t("dtoLabels.zincCoating.both") as string,
	};

	return coatingMap[zincCoating] ?? "n/a";
};
